package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.tse_location.TSELocationModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.TSELocationsRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class TSELocationsRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager
): TSELocationsRepository {

    override suspend fun getTSELocations(id: String): TSELocationModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                  query getShopCRs(${'$'}id: ID!) {
                      cashAssist {
                        getShop(id: ${'$'}id) {
                          id
                          cashRegisters {
                            id
                            name
                            hardwareId
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                    }

                    
                """.trimIndent()
            )


            putJsonObject("variables") {
                put("id",id)

            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }

    }

}